import tylerPic from "@/public/images/artists/tyler.png";
import { Artist } from "@/types/types";

export const tyler = {
  id: "103",
  name: "Tyler",
  image: tylerPic,
  description: `Tyler is a versatile rapper known for his smooth flow. He has a distinctive voice and passionate style.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftyler-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop"],
      secondary: ["Rapper", "Fast Rap", "Flow"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 48,
        high: 67,
      },
    },
  },
} as const satisfies Artist;
